import React from 'react';
import cx from 'classnames';
import { WEB_LINK_CLASS } from '@riotgames/accounts-react-components/lib/Typography';
import AppVersion from '../AppVersion';

const BASE_CLASS = 'footer-menu';
const links = [
  {
    href: 'https://support-leagueoflegends.riotgames.com/hc/ko',
    text: '고객센터'
  },
  {
    href: 'https://legal.kr.riotgames.com/privacy',
    text: '개인정보 처리방침'
  },
  {
    href: 'https://legal.kr.riotgames.com/tos',
    text: '사용약관'
  }
];

const Footer = () => {
  const classes = cx(BASE_CLASS);

  return (
    <footer className={classes}>
      <nav className={cx(`${BASE_CLASS}-links`, WEB_LINK_CLASS)}>
        {links.map((link, index) => (
          <span key={index}>
            <a
              href={link.href}
              className={cx('footer-menu__link', WEB_LINK_CLASS)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.text}
            </a>
            {index < links.length - 1 ? <span className={`${BASE_CLASS}-links__dot`}>&bull;</span> : null}
          </span>
        ))}
      </nav>
      <p className={'text__web-caption'}>© 2019 Riot Games, Inc. All rights reserved.</p>
      <AppVersion />
    </footer>
  );
};

export default Footer;
